import React, { useEffect, useState } from 'react';
import { Grid, Chip, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import api from '../../globals/axios';

const CropSelector = ({ selectedFarmId, selectedCropId, setSelectedCropId }) => {
  const [crops, setCrops] = useState([]);

  useEffect(() => {
    if (selectedFarmId) {
      api.get('farmer/crops/', {
        params: { farmlandId: selectedFarmId }
      })
        .then(res => setCrops(res.data))
        .catch(console.error);
    }
  }, [selectedFarmId]);
  
  const handleSelect = (id) => {
    setSelectedCropId(id);
  };

  return (
   <>
   {Array.isArray(crops) && crops.length > 0 ? (
        <Grid gap={1} textAlign="center">
            <Grid>
            <Typography variant="h6" textAlign="center">
                Select crop
            </Typography>
            </Grid>
            <Grid>
            {crops.map(crop => (
                <Chip
                key={crop.id}
                sx={{ m: 1, textAlign: 'center' }}
                label={crop.commodity?.name || 'Unnamed'}
                variant="outlined"
                onClick={() => handleSelect(crop.id)}
                icon={selectedCropId === crop.id ? <Check fontSize="small" /> : null}
                color={selectedCropId === crop.id ? 'success' : 'default'}
                />
            ))}
            </Grid>
            <Grid>
            </Grid>
        </Grid>
        ) : null}
    </>
  );
};

export default CropSelector;
